import ApiClient from '@afosto/api/ApiClient';

class Dataset {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Upload data
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Upload data as lines to the dataset
   * @returns {Promise}
   */
  attachData(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets/${id}/upload`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Read file
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Select a file and read it to be used as input
   * @returns {Promise}
   */
  attachFile(id, body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets/${id}/attach`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Create dataset
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new dataset container
   * @returns {Promise}
   */
  createDataset(body, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Export data
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Request data to be exported to CSV
   * @returns {Promise}
   */
  exportData(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets/${id}/export`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Get dataset
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a set of rows
   * @returns {Promise}
   */
  getDataset(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get lines
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Browse all dataset lines
   * @returns {Promise}
   */
  getLines(id, options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets/${id}/lines`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get datasets
   *
   * @param {Object} options - The additional request options
   * @description Get a set of rows
   * @returns {Promise}
   */
  listDatasets(options = {}) {
    return this.apiClient.request({
      url: `/cnt/datasets`,
      method: 'get',
      ...options,
    });
  }
}

export const dataset = new Dataset();

export default Dataset;
